// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__iwFA8","menuBtnBurger":"HamburgerMenu_menuBtnBurger__hX0Bh","open":"HamburgerMenu_open__MtfBs"};